var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangepassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 14.2235C9.65537 14.2235 9.37537 13.9435 9.37537 13.5985V11.7477C9.37537 11.4027 9.65537 11.1227 10.0004 11.1227C10.3454 11.1227 10.6254 11.4027 10.6254 11.7477V13.5985C10.6254 13.9435 10.3454 14.2235 10.0004 14.2235Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4249 7.38851C16.2563 8.22269 17.0086 9.84556 17.0086 12.5304C17.0086 16.7962 15.1094 18.3821 10.0003 18.3821C4.89111 18.3821 2.99194 16.7962 2.99194 12.5304C2.99194 9.84589 3.74405 8.22307 5.57495 7.3888V5.97959C5.61412 3.55959 7.53245 1.64875 9.94158 1.61792C11.1399 1.62375 12.2433 2.04959 13.0891 2.87459C13.9366 3.70125 14.4108 4.80625 14.4249 5.98875V7.38851ZM13.5052 8.33831C13.5573 8.36623 13.6138 8.38698 13.6733 8.39923C15.2285 8.99889 15.7586 10.244 15.7586 12.5304C15.7586 16.1004 14.4669 17.1321 10.0003 17.1321C5.53361 17.1321 4.24194 16.1004 4.24194 12.5304C4.24194 10.2436 4.77219 8.99848 6.32803 8.39889C6.38663 8.38673 6.44223 8.36631 6.49356 8.33889C7.3498 8.04679 8.49467 7.92956 10.0003 7.92956C11.5048 7.92956 12.6492 8.04662 13.5052 8.33831ZM6.82495 6.97619V5.98959C6.85245 4.26125 8.22828 2.88959 9.95825 2.86792C10.8216 2.86209 11.6099 3.17792 12.2174 3.77042C12.8249 4.36292 13.1649 5.15542 13.1749 5.99625V6.97604C12.2938 6.77315 11.2418 6.67956 10.0003 6.67956C8.7585 6.67956 7.70631 6.77319 6.82495 6.97619Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangepassword);
export default __webpack_public_path__ + "static/media/changepassword.d43ffb5ae4a6d2a9e565bc6e06915ce2.svg";
export { ForwardRef as ReactComponent };